// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-order--header[data-v-2c0af569] .l-header--plain__title{font-size:1em}.part-label[data-v-2c0af569],.reorder-button-label[data-v-2c0af569]{font-size:1.2em}.part-label[data-v-2c0af569]{font-weight:700}", ""]);
// Exports
module.exports = exports;
